const types = {
    SET_USERS: '[INFORMATION MOBILE] SET USERS',
    SET_SPIN: '[INFORMATION MOBILE] SET SPIN',
    SET_DETALIZATION_SPIN: '[INFORMATION MOBILE] SET DETALIZATION SPIN',
    SET_DETALIZATION: '[INFORMATION MOBILE] SET DETALIZATION',
    SET_NEW_USERS: '[INFORMATION MOBILE] SET NEW USERS',
    SET_COUNT_ONLINE: '[INFORMATION MOBILE] SET COUNT ONLINE'
}

export {
    types
}